/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import isString from"./isString";const decamelize=function(e,i){return isString(e)||(e=`${e}`),i=i||"-",e.replace(/([a-z])([A-Z])/g,`$1${i}$2`).toLowerCase()};export default decamelize;